import {
  Paper,
  Popper,
  Stack,
  Typography,
  Box,
  Button
} from '@material-ui/core';

const BookOptions = ({ opened, anchorEl, bookList, onSelect }) => {
  console.log(bookList)
  return (
    <Popper placement='bottom-end'
            open={ opened }
            anchorEl={ anchorEl }
            style={ { zIndex: 2} }
    >
      <Paper style={{backgroundColor: "#eee"}}>
        <Stack spacing={ 1 } padding={ 2 }>
          { bookList.map(b => (
            <Button type="button" key={ b.book_id } sx={ { width: 400, display: 'flex', backgroundColor: "#fff", cursor: "pointer" } } onClick={() => onSelect(b)}>
              <img src={ b.cover } style={ { width: 100 } } />
              <Box sx={ { width: 20 } } />
              <Box item xs={ 4 }>
                <Typography>
                  <b>{ b.title }</b>
                  <br /> { b.authors }
                  <br /> ISBN { b.isbn }
                  <br /> ID { b.book_id }
                </Typography>
              </Box>
            </Button>
          )) }
        </Stack>
      </Paper>
    </Popper>
  );
};

export default BookOptions;
